import { action, computed, makeAutoObservable, makeObservable, observable, runInAction } from "mobx";
import firebaseAgent from "../api/firebaseagent";
import { Product } from "../models/product";
import { BaseStore } from "./baseStore";
import { RootStore } from "./rootStore";

export default class NewArrivalProductsStore extends BaseStore<Product> {
    productreload = true;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            // items: observable,
            // selectedItem: observable,
            // isLoaded: observable,
            // loadAll: action,
            // register: action,
            // manage: action,
            //delete: action,
            //setItem: action                        
        });
    }

    // Link this store to the specific service in firebaseAgent
    protected getService() {
        // We use the specific service logic defined in the refactored Agent
        return firebaseAgent.newarrivalProductsCollectionsService; 
    }

    // Aliases to match your existing code naming conventions
    get product() { return this.selectedItem || new Product(); }
    set product(val: Product) { this.selectedItem = val; }
    get products() { return this.items; }

    // Unique Product Logic
    loadProductList = async () => {
        await this.loadAll();
    }

    loadProduct = async (id: string) => {
        return this.getItem(id);
    }

    setProductReload = async (state: boolean) => {
        runInAction(() => {
            this.productreload = state;
        });
    }

    get productByName() {
        return [...this.items].sort((a, b) => {
            // Add sorting logic if needed
            return 0;
        });
    }
}